import airfrance from 'static/images/logos/airlines/airfrance.svg';
// import blueair from 'static/images/logos/airlines/blueair.svg';
import britishAirways from 'static/images/logos/airlines/british_airways.svg';
import easyjet from 'static/images/logos/airlines/easyjet.svg';
import flyEmirates from 'static/images/logos/airlines/fly_emirates.svg';
import klm from 'static/images/logos/airlines/klm.svg';
import lufthansa from 'static/images/logos/airlines/lufthansa.svg';
import norwegian from 'static/images/logos/airlines/norwegian.svg';
// import ryanair from 'static/images/logos/airlines/ryanair.svg';
import sas from 'static/images/logos/airlines/sas.svg';
import tarom from 'static/images/logos/airlines/tarom.svg';
import vueling from 'static/images/logos/airlines/vueling.svg';
import wizz_air from 'static/images/logos/airlines/wizz_air.svg';
import aeagen from 'static/images/logos/airlines/aegean.svg';
import airBaltic from 'static/images/logos/airlines/airBaltic.svg';
// import airmalta from 'static/images/logos/airlines/airmalta.svg';
import lot_polish_airlines from 'static/images/logos/airlines/lot_polish_airlines.svg';
import turkish_airlines from 'static/images/logos/airlines/turkish_airlines.svg';
import fly_dubai from 'static/images/logos/airlines/fly_dubai.svg';
import swiss_air from 'static/images/logos/airlines/swiss_air.svg';
import websiteIds from 'constants/website.config';

/**
 * Get flight carrier icons/logos (grey) based on the provided websiteId.
 *
 * @param {number} websiteId - WebsiteId.
 * @returns {Array} - The array of icons.
 */

export const getFlightCarriersIcons = (websiteId) => {
  switch (websiteId) {
    //Wakacje
    case websiteIds.Wakacje.ID:
      return [
        swiss_air,
        turkish_airlines,
        flyEmirates,
        fly_dubai,
        britishAirways,
        lufthansa,
        wizz_air,
        // ryanair,
        aeagen,
        klm,
        lot_polish_airlines,
      ];

    //Vola
    case websiteIds['Vola.ro'].ID:
      return [
        wizz_air,
        // ryanair,
        easyjet,
        tarom,
        airfrance,
        klm,
        lufthansa,
      ];

    //Default
    default:
      return [
        britishAirways,
        easyjet,
        flyEmirates,
        lufthansa,
        norwegian,
        // ryanair,
        sas,
        vueling,
        aeagen,
        wizz_air,
        airBaltic,
      ];
  }
};
